var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"content-class":"loginpage-overlay meta-dialog custom-overlay","persistent":"","scrollable":""},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('LoginPage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }